import { format, parseISO } from 'date-fns';

export default function joinDate(date:string, time: string): any {
  const newData = format(new Date(date), 'yyyy-MM-dd');
  const newtempo = format(new Date(time), 'HH:mm');

  const newDateTime = `${newData} ${newtempo}`;
  const parsedDate = parseISO(newDateTime);
  return parsedDate;
}
